import dynamic from 'next/dynamic';
import { SkeletonLoader } from '@/shared/ui/skeleton/skeleton';

const DynamicJackpotLobbyWidget = dynamic(
  () => import('./jackpot-lobby-widget'),
  {
    ssr: false,
    loading: () => <SkeletonLoader height={220} />,
  }
);

export default DynamicJackpotLobbyWidget;
export { default as JackpotGameWidget } from './jackpot-game-widget';
